/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.pages.forms.donations.controllers', [
  'angularUUID2',
  'colorpicker.module',
  'acme.common.service.api',
  'acme.common.service.posConfig',
  'acme.common.factory.gridState'
])

.controller('PosCreatePagesFormsDonationsController', ['$scope', '$timeout', '$filter', 'uuid2', 'ApiService', 'PosConfigService', 'GridStateFactory', function($scope, $timeout, $filter, uuid2, ApiService, PosConfigService, GridStateFactory) {

    $scope.posCreatePagesFormsDonations = {

      queryTimer: false,

      model: [],
      list: [],

      title: '',
      subTitle: '',
      color: '',
      selected: '',
      showIcon: false,
      reduceList: false,
      isLoaded: false,

      gridState: new GridStateFactory(),

      pageSize: 20,

      lastSearchQuery: '',
      totalServerItems: 1,
      currentDonation: false,

      init: function() {
        $scope.$on('PosCreatePagesFormsController::Update', this.onPosCreatePagesFormsControllerUpdate);

        $scope.$watch('posCreatePagesFormsDonations.selected', this.onSelected);

        $scope.$on('destroy', function() {
          $timeout.cancel($scope.posCreatePagesFormsDonations.queryTimer);
        });
      },

      showAutoComplete: function(field) {

        var input = $('#'+field);

        this.reduceList = false;

        $timeout(function () {
          input.trigger('focus');
        }, 0);

      },

      hasSelected: function() {
        return (this.selected && typeof this.selected === 'object');
      },

      findDonation: function(id) {

        var i, ii,
          r = false;

        for (i=0,ii=this.list.length;i<ii;i++) {
          if (""+this.list[i].id === ""+id) {
            r = {
              donation: this.list[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      getTitle: function() {
        var r = 'Enter a title';
        return r;
      },

      process: function (donations, count) {
        var r = donations,
          currentCount = (this.gridState.gridState.page || 1) * this.gridState.gridState.pageSize;

        //if there are more items for this search, show pagination
        if (count && count > currentCount) {
          this.showMore = {
            showMoreLabel: 'Show '+ this.pageSize +' more of ' + count,
            hasMore: true
          };
        } else {
          this.showMore = {
            showMoreLabel: '',
            hasMore: false
          };
        }

        return r;
      },

      remove: function() {
        $scope.$emit('PosCreatePagesFormsController::RemoveTile', this.model);
      },

      cancel: function() {
        $scope.$emit('PosCreatePagesFormsController::Cancel', this.model);
      },

      resetDonation: function() {
        var foundDonation, self = $scope.posCreatePagesFormsDonations;
        $timeout(function() {
          //reset donation selected if no donation is chosen
          if (!self.hasSelected()) {
            foundDonation = self.findDonation(self.model.id);

            if (foundDonation || self.currentDonation) {
              self.selected = !foundDonation ? self.currentDonation : self.list[foundDonation.index];
            }
          }
          this.reduceList = false;
        },0);
      },

      done: function () {
        this.model.name = '';

        if (this.title) {
          this.model.name = this.title;
        } else if (this.selected && this.selected.name) {
          this.model.name = this.selected.name;
        }

        if (this.selected) {
          this.model.id = this.selected.id;
        }

        this.model.icon = (this.showIcon) ? 'donation' : 'none';

        this.model.subTitle = this.subTitle;
        this.model.color = PosConfigService.tiles.rgbaToColor(this.color);
        this.model.type = 'donation';
        if (this.selected.price) {
          this.model.price = this.selected.price;
        }

        if (this.model.config.pageId) {
          this.model.config.pageId = null;
          delete this.model.config.pageId;
        }

        PosConfigService.updateTile(PosConfigService.pages.getSelectedPageId(), this.model);
        $scope.$emit('PosCreatePagesFormsController::UpdateTile');
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onSelected: function(n, o) {
        var self = $scope.posCreatePagesFormsDonations;

        if (self.hasSelected() && self.model.id == self.selected.id) {
          if (self.model.name && self.model.name.length) {
            self.title = self.model.name;
          }else{
            self.title = '';
          }
          self.subTitle = self.model.subTitle;
        }else {
          self.title = '';
          self.subTitle = '';
        }
      },

      onPosCreatePagesFormsControllerUpdate: function(e, data) {
        var foundDonation,
            self = $scope.posCreatePagesFormsDonations;

        if (data.config.type === 'donation') {
          self.selected = '';

          if (data && !data.id) {
            data.id = uuid2.newuuid();
          }
          self.model = data;
          self.currentDonation = angular.copy(data);
          self.selected = self.currentDonation;
          self.color = PosConfigService.tiles.colorToRgba(self.model);
          self.showIcon = (self.model.icon && self.model.icon !== 'none');
          self.isLoaded = true;
        }
      }

    };

    $scope.posCreatePagesFormsDonations.init();

}]);